import { forwardRef } from "react";
import "./IdCard.css";

/**
 * KASA Players Identification Card — id_sample.png 디자인 재현.
 * `data` 는 GET /api/admin/players/:id/card 응답.
 * ref 는 PNG 캡처 대상 카드 루트 엘리먼트에 연결됩니다.
 */
const IdCard = forwardRef(function IdCard({ data }, ref) {
  if (!data) return null;

  return (
    <div className="idcard" ref={ref}>
      {/* 배경 워터마크 (우측 협회 로고) */}
      <img
        src="/images/kasausa_logo_black.png"
        alt=""
        className="idcard-watermark"
        aria-hidden="true"
      />

      {/* 헤더: 로고 + 제목 */}
      <div className="idcard-header">
        <img
          src="/images/kasausa_logo.png"
          alt="KASAUSA"
          className="idcard-logo"
        />
        <h1 className="idcard-title">KASA Players Identification Card</h1>
      </div>

      {/* 아이디 번호 */}
      <div className="idcard-idno">{data.id_number}</div>

      {/* 본문: 사진 + 정보 */}
      <div className="idcard-body">
        <div
          className="idcard-photo"
          style={
            data.photo_url
              ? { backgroundImage: `url(${data.photo_url})` }
              : undefined
          }
        >
          {!data.photo_url && (
            <span className="idcard-photo-placeholder">Photo</span>
          )}
        </div>

        <div className="idcard-fields">
          <div className="idcard-field">
            <span className="idcard-label">Name:</span>
            <span className="idcard-value">
              {data.name_en || "—"}
              {data.name_kr ? (
                <span className="idcard-value-kr">{data.name_kr}</span>
              ) : null}
            </span>
          </div>
          <div className="idcard-field">
            <span className="idcard-label">DOB:</span>
            <span className="idcard-value">{data.date_of_birth || "—"}</span>
          </div>
          <div className="idcard-field">
            <span className="idcard-label">소속:</span>
            <span className="idcard-value">{data.team_name || "—"}</span>
          </div>

          <div className="idcard-dates">
            <div>Issue Date: {data.issue_date}</div>
            <div>Expiration Date: {data.expiration_date}</div>
          </div>
        </div>
      </div>

      {/* 푸터: 협회명 + 인장 */}
      <div className="idcard-footer">
        <span className="idcard-org">재미대한축구협회</span>
        <img src="/images/sig.png" alt="인장" className="idcard-seal" />
      </div>
    </div>
  );
});

export default IdCard;
